import { Notification } from '../types/notification.types';

export const mockNotifications: Notification[] = [
	{
		id: '1',
		title: 'New Schedule Published',
		message: 'Your schedule for next week has been published. Please review it.',
		timestamp: new Date(Date.now() - 1000 * 60 * 5), // 5 minutes ago
		isRead: false,
		type: 'info',
		actionUrl: '/manager/hyperscheduler',
	},
	{
		id: '2',
		title: 'Shift Request Approved',
		message: 'Your shift swap request for Friday has been approved.',
		timestamp: new Date(Date.now() - 1000 * 60 * 30), // 30 minutes ago
		isRead: false,
		type: 'success',
	},
	{
		id: '3',
		title: 'Onboarding Task Pending',
		message: 'You have 3 new employees waiting for onboarding completion.',
		timestamp: new Date(Date.now() - 1000 * 60 * 60 * 2), // 2 hours ago
		isRead: true,
		type: 'warning',
		actionUrl: '/manager/onboarding',
	},
	{
		id: '4',
		title: 'Checklist Overdue',
		message: 'Opening checklist for today is overdue. Please complete it.',
		timestamp: new Date(Date.now() - 1000 * 60 * 60 * 4), // 4 hours ago
		isRead: false,
		type: 'error',
		actionUrl: '/manager/checklist',
	},
	{
		id: '5',
		title: 'New Broadcast Message',
		message: 'Manager has sent a broadcast message to all staff.',
		timestamp: new Date(Date.now() - 1000 * 60 * 60 * 6), // 6 hours ago
		isRead: true,
		type: 'info',
		actionUrl: '/manager/broadcast',
	},
	{
		id: '6',
		title: 'Guest Feedback Received',
		message: 'New 5-star review from a guest at Table 12.',
		timestamp: new Date(Date.now() - 1000 * 60 * 60 * 24), // 1 day ago
		isRead: true,
		type: 'success',
	},
	{
		id: '7',
		title: 'Event Reminder',
		message: 'VIP event scheduled tomorrow at 7 PM. Prepare accordingly.',
		timestamp: new Date(Date.now() - 1000 * 60 * 60 * 24 * 2), // 2 days ago
		isRead: true,
		type: 'info',
		actionUrl: '/manager/events',
	},
];
